<div class="h64 flex relative item-center ph24 border-style">
  <div (click)="handleCollapse()" class="w20 h20">
    @if (isCollapsed) {
    <div id="u263" class="ax_default iconfont transition notrs cursor">
      <div id="u263_div" class=""></div>
      <div id="u263_text" class="text ">
        <p><span></span></p>
      </div>
    </div>
    } @else {
    <div id="u260" class="ax_default iconfont transition notrs cursor">
      <div id="u260_div" class=""></div>
      <div id="u260_text" class="text ">
        <p><span></span></p>
      </div>
    </div>
    }
  </div>
  <span class="flex-1"></span>
  <nz-select [nzPlaceHolder]="'Language' | translate" [(ngModel)]="currentLang" class="w110"
    (ngModelChange)="handleLanguageChange()">
    <nz-option [nzLabel]="'Zh' | translate" nzValue="zh"></nz-option>
    <nz-option [nzLabel]="'En' | translate" nzValue="en"></nz-option>
    <nz-option [nzLabel]="'Fr' | translate" nzValue="fr"></nz-option>
    <!-- <nz-option [nzLabel]="'Ar' | translate" nzValue="ar"></nz-option> -->
    <nz-option [nzLabel]="'Zh_TW' | translate" nzValue="zh_TW"></nz-option>
  </nz-select>
  @if (imageAvatarUrl) {
    <nz-avatar [nzSrc]="imageAvatarUrl" nz-dropdown [nzDropdownMenu]="menu" class="ml10"></nz-avatar>
  } @else {
    <nz-avatar [nzText]="imageAvatarText" nz-dropdown [nzDropdownMenu]="menu" class="ml10"></nz-avatar>
  }
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu nzSelectable class="text-center">
      <li nz-menu-item>
        <div class="mw180 word-break">{{userName}}</div>
        <div class="mw180 word-break">{{userEmail}}</div>
      </li>
      <li nz-menu-item (click)="openUserDetails()">
        <span nz-icon nzType="user" nzTheme="outline" class="fz16"></span>
        <span class="ml20">{{'PersonalInformation' | translate}}</span>
      </li>
      <li nz-menu-item (click)="logout()">
        <span nz-icon nzType="logout" nzTheme="outline" class="fz16"></span>
        <span class="ml20">{{'LogOut' | translate}}</span>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>
@if (breadcrumbList.length > 0) {
<nz-breadcrumb class="pv8 ph24 border-style">
  @for (item of breadcrumbList; track $index;) {
  <nz-breadcrumb-item>
    @if (item.url) {
    <a [routerLink]="[item.url]">{{item.name | translate}}</a>
    } @else {
    <span>{{item.name | translate}}</span>
    }
  </nz-breadcrumb-item>
  }
</nz-breadcrumb>
}